import { ReactNode } from 'react';

export interface ControlGroupProps {
  label: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Group component for organizing related controls.
 * Provides consistent spacing and labeling.
 */
export function ControlGroup({ 
  label, 
  description, 
  children,
  className = '',
}: ControlGroupProps) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-medium text-muted-foreground">
          {label}
        </span>
      </div>
      {description && (
        <p className="text-[11px] text-muted-foreground">{description}</p>
      )}
      <div className="mt-1">{children}</div>
    </div>
  );
}









